<template>
  <transition :name="transitionName" @before-enter="beforeEnter" @enter="enter" @leave="leave">
    <slot v-if="show"></slot>
  </transition>
</template>

<script>
export default {
  name: 'FadeTransition',
  props: {
    show: {
      type: Boolean,
      default: true,
    },
    duration: {
      type: Number,
      default: 200,
    },
    delay: {
      type: Number,
      default: 0,
    },
    ease: {
      type: String,
      default: 'ease-out',
    },
    mode: {
      type: String,
      default: '', // '', 'in-out', 'out-in'
    },
  },
  computed: {
    transitionName() {
      return this.mode ? `fade-${this.mode}` : 'fade';
    },
  },
  methods: {
    beforeEnter(el) {
      if (this.mode === 'out-in') {
        el.style.opacity = 0;
      }
    },
    enter(el, done) {
      const delay = this.mode === 'out-in' ? 0 : this.delay;
      setTimeout(() => {
        el.style.transition = `opacity ${this.duration}ms ${this.ease}`;
        // Force reflow
        el.offsetHeight;
        el.style.opacity = 1;
        setTimeout(done, this.duration);
      }, delay);
    },
    leave(el, done) {
      el.style.transition = `opacity ${this.duration}ms ${this.ease}`;
      el.offsetHeight;
      el.style.opacity = 0;
      setTimeout(done, this.duration);
    },
  },
};
</script>

<style scoped>
/* Default fade transition */
.fade-enter-active,
.fade-leave-active {
  transition: opacity var(--fade-duration, 200ms) var(--fade-ease, ease-out);
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

/* Out-in mode - ensures content fades out before new content fades in */
.fade-out-in-enter-active,
.fade-out-in-leave-active {
  transition: opacity var(--fade-duration, 200ms) var(--fade-ease, ease-out);
}

.fade-out-in-enter-from {
  opacity: 0;
}

.fade-out-in-leave-to {
  opacity: 0;
}
</style>
